import React from 'react'

export default ({ fill = '#000000' }) => (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enableBackground="new 0 0 1000 1000" xmlSpace="preserve">
        <g>
            <path fill={fill} d="M945.7,989.4L10,53.8L54.3,9.4L990,945.1L945.7,989.4z"/>
            <path fill={fill} d="M10,946.2L945.7,10.6L990,54.9L54.3,990.6L10,946.2L10,946.2z"/>
        </g>
    </svg>
)